<template>
    <div>
        <table width="480" cellpadding="0" border="0" align="center">
            <tbody>
                <tr>
                    <td align="center">
                        <div v-html="message"></div>
                        <center>
                            <div class="session">
                                <div id="sessionBox">
                                    <table><tbody><tr><td id="sessionTd">
                                        <font style="color:red; font-weight: bold;">{{seconds}}</font>秒後に{{$t('sessionErr.labels.link')}}
                                    </td></tr></tbody></table>
                                </div>
                            </div>
                        </center>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SiteConstants from 'assets/const/SiteConstants.json';
import common from "assets/js/common";
export default {
    name: 'SessionError',
    /*
    * Declare variable and set default value
    */
    data() {
        return {
            SiteConstants: SiteConstants,
            site: "",
            seconds: 5,
            interval: null,
            message: null
        };
    },
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        common.removeLocalStorageEcSite(_this.site);

        // 残り時間を０秒に設定している場合はTOPへ遷移
        if (this.seconds == 0) {
            this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 1}});
        } else {
            _this.interval = setInterval(function () {
                _this.updateTime(this)
            }, 1000);
        }
        const url = './'+this.SiteConstants.PG010MAIN + "?pageNo=1";
        history.pushState(null,null,url);
    },
    methods: {
        gotoLoginPage: function() {
            clearInterval(this.interval);
            this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 18}});
        },
        gotoTopPage: function() {
            this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 1}});
        },
        updateTime: function(interval) {
            this.seconds = this.seconds - 1;
            if(this.seconds == -1) {
                clearInterval(interval);
                this.gotoTopPage();
            }
        }
    },
    created: function(){
      var data = this.$route.params;
      if (data.seconds != null) {
          this.seconds = data.seconds;
      }
      if(data.messageError != null){
        this.message = data.messageError;
      }
    }
}
</script>

<style scoped>
#session-timeout{
    width:100%;
    padding:50px;
}

#session-timeout div{
    margin:0 auto;
    border:solid 2px #5d4037;
    padding:20px;
}

#session-timeout div p{
    font-size:16px;
}

#session-timeout div input[type="button"]{
    width:100%;
    margin-top:30px;
    padding:10px 0;
    font-size:16px;
    background-color: #4c87d1;
    border-radius: 4px;
    color: #ffffff;
    border: 0;
    margin: 0;
}

h2 {
    color: #5d4037;
    font-weight: bold;
    text-align: left;
    border-bottom:solid 2px #5d4037;
    padding-bottom:10px;
    margin-bottom:20px;
    font-size: 18px;
    letter-spacing: 1px;
    margin-bottom: 16px;
    position: relative;
}

input[type="button"] {
    background-color: #4c87d1;
    border-radius: 4px;
    color: #fff;
    -webkit-appearance: none;
    cursor: pointer;
    font-family: 'Lucida Grande','Hiragino Kaku Gothic ProN', Meiryo, sans-serif;
    -webkit-transition: all .3s;
    transition: all .3s;
    vertical-align: baseline;
}

input[type="button"]:hover {
    filter: alpha (opacity=70);
    -moz-opacity: 0.7;
    -webkit-opacity: 0.7;
    opacity: 0.7;
}
</style>
